module.exports = __webpack_public_path__ + "img/trysome.a7eb0d9f.png";